/**
 * api接口的统一出口
 */

 // 导入其他模块的接口
import module from './module';
import personInfo from './personinfo';
import research from './research';
import publication from './publication';
import students from './students';

const API = {
    module,
    personInfo,
    research,
    publication,
    students,
    // ...
};

export default API;
